module.exports = __webpack_public_path__ + "img/3.199b6f8f.jpg";